<template>
  
  <div class="tabs-container ng-scope" style="padding-bottom:50px;margin-top:18px;">
    <div id="wrapperp">
      <ul class="nav nav-tabs">
        <li
          class="tabLi"
          v-for="(data,$index) in langData"
          :key="$index"
          :class="{'active':$index==0}"
        >
          <div class="tabDiv" @click="changeTab($index)"></div>
          <a
            :class="true?'tab'+$index:''"
            data-toggle="tab"
            :href="true?'#tab-'+$index:''"
            aria-expanded="true"
            @click="showTab($event,$index)"
          >{{ $t("message." + data) }}</a>
        </li>
      </ul>
    </div>
    <form method="get" class="form-horizontal" id="baseInfo" novalidate="novalidate">
      <div class="tab-content">
        <div
          :id="'tab-'+index"
          v-for="(langItem, index) in recourceCategoryDetail.langData"
          :key="index"
          class="tab-pane"
        >
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  {{$t('message.name')}} - {{langLabel(langItem.langCode)}}
                  <span style="color:red">*</span>
                </label>
                <div class="col-sm-10">
                  <div>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="langItem.name"
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      :name="'Name - '+langLabel(langItem.langCode)"
                    />
                  </div>
                  <label class="error">{{ errors.first('Name - '+langLabel(langItem.langCode)) }}</label>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <div v-if="$route.query.id" class="btn btn-primary" @click="Delete()">{{$t("message.Delete") }}</div>
                    <div class="btn btn-primary" @click="submit()">{{$t("message.Save") }}</div>
                    <div class="btn btn-white" @click="showWarning()">{{$t("message.Cancel") }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      recourceCategoryDetail:{
      }
    };
  },
  created() {
    let langData = [];
    this.langKey.forEach(element => {
      langData.push({ langCode: element });
    });
    this.recourceCategoryDetail.langData = langData;
    this.init();
  },
  mounted() {
    setTimeout(function(){
      $(".tab" + 1)
        .parent()
        .find("a")
        .click();

      $(".tab" + 0)
        .parent()
        .find("a")
        .click();
    })
  },
  methods: {
    async init() {
      let id = this.$route.query.id;
      if (id) {
        let obj = this.getAuthObj;
        obj.id = id;
        let data = await this.$store.dispatch("getResourceGroupDetail", this.setFormData(obj));
        var langData = [];
        this.langKey.forEach(element => {
          for(var i=0;i<data.data.result.langData.length;i++){
            if(data.data.result.langData[i].langCode==element){
              langData.push(data.data.result.langData[i])
            }
          }
        });
        data.data.result.langData = langData;
        this.$set(this, "recourceCategoryDetail", data.data.result);
      } else {
      }
    },
    showWarning(type) {
      var that = this;
      if (!type) {
        that.$router.go(-1);
      } else if (type == 1) {
        this.$store.commit("setwarning", {
          string: this.$i18n.t("message.deleteContent"),
          boolean: true,
          button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.callDelete();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });
              }
            }]
        });
      }
    },
    async submit() {
      try {
        let vresult = await this.$validator.validate();
        if (!vresult) {
          this.fillInRequired();
          return;
        }
        let obj = this.getAuthObj;
        for(var key in this.recourceCategoryDetail){
          obj[key] = this.recourceCategoryDetail[key];
        }
        obj.langData = JSON.stringify(obj.langData);
        if(this.$route.query.id){
           var  data = await this.$store.dispatch("updateResourceGroup", this.setFormData(obj));
        }else{
           var  data = await this.$store.dispatch("createResourceGroup", this.setFormData(obj));
        }
        
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    Delete() {
      this.showWarning(1);
    },
    async callDelete() {
      try {
        let obj = this.getAuthObj;
        obj.id = [this.$route.query.id];
        let data = await this.$store.dispatch("deleteResourceGroup", this.setFormData(obj));
        if (data.data.errorCode === 0) {
          this.$router.go(-1);
        }
      } catch (err) {
        console.error(err);
      }
    },
    langLabel(lang) {
      if (lang === "en_US") {
        return "EN";
      } else if (lang === "zh_HK") {
        return "T. Chi.";
      } else if (lang === "zh_CN") {
        return "S. Chi.";
      }
    },
    changeTab: function(id) {
      $(".tab" + id)
        .parent()
        .find("a")
        .click();
    },
    showTab: function($event, tabId) {
      $event.preventDefault();
      switch (tabId) {
        case "1":
          $scope.tab1 = true;
          $($event.target).tab("show");
          break;
        case "2":
          $scope.tab2 = true;
          $($event.target).tab("show");
          break;
      }
    },
  }
};
</script>
